import { useRef, useState } from "react";
import { Card, Collapse, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function DeliveryInstructionsCard({ deliveryDetails, setDeliveryDetails }) {
    const [open, setOpen] = useState(false);
    const taRef = useRef(null);
    const value = deliveryDetails.instruction || "";

    const autoGrow = (el) => {
        if (!el) return;
        el.style.height = "auto";
        el.style.height = `${el.scrollHeight}px`;
    };

    const handleChange = (e) => {
        const val = e.target.value;
        setDeliveryDetails(prev => ({ ...prev, instruction: val }));
        autoGrow(e.target);
    };

    return (
        <Card className="mb-3 shadow-sm">
            <Card.Header
                role="button"
                onClick={() => setOpen(v => !v)}
                aria-controls="delivery-instructions-collapse"
                aria-expanded={open}
                className="d-flex align-items-center justify-content-between"
            >
                <span className="cartpage list-group-item fw-semibold">Delivery instructions</span>
                <FontAwesomeIcon
                    icon="fa-solid fa-chevron-down"
                    className="ms-2"
                    style={{ transition: "transform .2s ease", transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
                />
            </Card.Header>

            <Collapse in={open}>
                <div id="delivery-instructions-collapse">
                    <Card.Body className="pt-3">
                        <Form.Group>
                            <Form.Control
                                ref={taRef}
                                as="textarea"
                                rows={1}                         // start small…
                                placeholder='e.g., "Call on arrival", "Leave at door", "Use side gate", etc.'
                                value={value}
                                onChange={handleChange}
                                className="w-100"

                                style={{
                                    overflow: "hidden",           // smooth auto-grow
                                    resize: "vertical",           // still allow manual resize
                                    minHeight: "120px",           // feels ‘full length’ out of the box
                                    maxWidth: "100%"
                                }}
                                onFocus={(e) => autoGrow(e.target)}
                            />
                        </Form.Group>
                    </Card.Body>
                </div>
            </Collapse>
        </Card>
    );
}
